// This is compiled by parcel with `npm run build` or `npm run dev`

// Import scripts
import "./src/init-foundation.js"; // initiates foundation js
import "./src/wp-foundation.js"; //
import "./src/lozad.js";
// import "./src/lead-source.js"; // lead source
import "./src/aos.js"; // animations
import "./src/lity.js";
import "./src/upcoming-filters.js";
import "./src/main.js";

// Imports Individual Component Scripts
import "../../components/ImageGalleryHorizontal/scripts.js";

import "./../../node_modules/aos/dist/aos.css";
import "./../../assets/styles/scss/style.scss";
